// extracted by mini-css-extract-plugin
export var fadeIn = "_gn-1";
export var modalContent = "_gn-3";
export var overlay = "_gn-0";
export var popoverContent = "_gn-2";
export var results = "_gn-5";
export var searchInputWrapper = "_gn-4";